const menu_management_zh = {
  edit_menu_info:'编辑菜单信息',
  empty_menu_name:'请输入菜单名称',
  empty_menu_code:'请输入菜单编码',
  empty_parent_num:'请选择父级编号',
  empty_req_addr:'请输入请求地址',
  empty_sys_type:'请选择系统分类'
}

export default menu_management_zh



// WEBPACK FOOTER //
// ./src/common/lang/menu_management/menu_management_zh.js